// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"440":"1548ef08586f90f9eb73","581":"48188bee6abb1a4bc2a3"}[chunkId] + ".js";
};